<script setup>
import { withQuery } from "ufo";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Jakarta");

const deleteDialog = ref(false);

definePage({
  meta: {
    layout: "default",
  },
});

const route = useRoute();
const router = useRouter();

const pageTitle = "Parameter Setting System";
const loading = ref();

const load = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 3000);
};

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "System",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/parameter-setting-system",
  },
  {
    title: "Update",
    to: null,
  },
];

const refForm = ref();

const { data: dataQuery } = await useApi(
  withQuery("/cms/parameter/" + route.params.id, {
    method: "GET",
  })
);
const data = dataQuery ? dataQuery.value?.data : [];

const form = ref({
  value: data ? data.value : null,
});

/*
 * Form Submit
 * */
const valid = ref("");
const errors = ref("");
const sendData = async (e) => {
  try {
    load();
    var res = await $api("/cms/parameter/" + route.params.id, {
      method: "PATCH",
      body: e,
      onResponseError({ response }) {
        errors.value = response._data.message;

        setTimeout(() => (errors.value = false), 10000);
      },
    });

    if (res.statusCode === 200 || res.statusCode === 201) {
      valid.value = res.message;
      setTimeout(() => (valid.value = false), 10000);
      setTimeout(
        () => router.push({ path: "/admin/parameter-setting-system" }),
        2000
      );
    }
  } catch (err) {
    errors.value = err._data.message;

    setTimeout(() => (errors.value = false), 10000);
  }
};

const onSubmit = (e) => {
  refForm.value?.validate().then(({ valid: isValid }) => {
    if (isValid) sendData(e);
  });
};
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <VForm
    ref="refForm"
    @submit.prevent="
      () => {
        onSubmit(form);
      }
    "
  >
    <VRow>
      <VCol cols="12" lg="10">
        <VAlert v-show="valid" type="success">
          {{ valid }}
        </VAlert>
        <VAlert v-show="errors" type="error">
          {{ errors }}
        </VAlert>
        <VRow class="d-flex align-center flex-wrap justify-space-between">
          <VCol cols="6">
            <div class="my-4">
              <h4 class="text-h4 mb-1">Update {{ pageTitle }}</h4>
              <h6 class="text-h6">
                Parameter No <strong>{{ data.parameterNo }}</strong>
              </h6>
            </div>
          </VCol>
          <VCol class="" cols="6">
            <div class="d-flex gap-4 align-end float-end">
              <VBtn
                :to="{ path: '/admin/parameter-setting-system' }"
                color="secondary"
                type="button"
                variant="tonal"
              >
                Back
              </VBtn>
              <VBtn
                :disabled="loading"
                :loading="loading"
                color="primary"
                type="submit"
              >
                Update

                <template #loader>
                  <span class="custom-loader">
                    <VIcon class="text-white" icon="tabler-refresh" />
                  </span>
                </template>
              </VBtn>
            </div>
          </VCol>
        </VRow>

        <VCard class="v-card-data">
          <VCardTitle class="my-4 ms-2"
            >Parameter Setting System Information
          </VCardTitle>
          <VCardText>
            <VTable class="text-no-wrap" density="compact">
              <tbody>
                <tr>
                  <td>Parameter No.</td>
                  <td>{{ data.parameterNo }}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>{{ data.name }}</td>
                </tr>
                <tr>
                  <td>Key</td>
                  <td>{{ data.key }}</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>
                    {{ data.description }}
                  </td>
                </tr>
                <tr>
                  <td>Check type</td>
                  <td>{{ data.checkType }}</td>
                </tr>
                <tr>
                  <td>Length of value</td>
                  <td>{{ data.maxLengthValue }}</td>
                </tr>
                <tr>
                  <td>Last update</td>
                  <td>
                    {{
                      data.updatedAt
                        ? moment(data.updatedAt).format("LLL")
                        : null
                    }}
                  </td>
                </tr>
              </tbody>
            </VTable>
          </VCardText>
          <VCardText>
            <VRow>
              <VCol cols="12" lg="6">
                <AppTextField
                  v-model="form.value"
                  :rules="[requiredValidator]"
                  label="Value"
                  placeholder="Input Words"
                />
              </VCol>
            </VRow>
          </VCardText>
          <VCardText>
            <VLabel class="my-5 text-error">* Mandatory</VLabel>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </VForm>
</template>
